/**
 * A failed load: the API's error, in the interface's language, and a way to
 * ask again. A page that renders a skeleton forever on a failure looks
 * exactly like one that is still loading.
 */
import { Button, Card } from "./ui";
import { errorMessage, useTranslation } from "@/lib/i18n";

export function QueryError({
  error,
  onRetry,
  retrying,
}: {
  error: unknown;
  onRetry: () => void;
  retrying?: boolean;
}) {
  const { t, i18n } = useTranslation();
  return (
    <Card>
      <div role="alert" style={{ color: "var(--atlas-danger)" }}>
        {errorMessage(error, t, i18n.language)}
      </div>
      <div className="mt-4">
        <Button disabled={retrying} onClick={onRetry}>
          {t("common.tryAgain")}
        </Button>
      </div>
    </Card>
  );
}
